import { render } from "./NotVerifiedModal.vue?vue&type=template&id=613855f8&ts=true&lang=pug"
import script from "./NotVerifiedModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotVerifiedModal.vue?vue&type=script&lang=ts&setup=true"

import "./NotVerifiedModal.vue?vue&type=style&index=0&id=613855f8&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__